import React, { useState } from "react";
import { Button, Col, Row, Tabs } from "antd";
import { useTranslation } from "react-i18next";

import { activeWallet } from "../../api";
import { commonUtil } from "../../utils";

interface Props {
  handleChangeView: any;
  fetchCustomerWallet: any;
}

const WalletActiveAccount: React.FC<Props> = ({
  handleChangeView,
  fetchCustomerWallet,
}) => {
  const { t } = useTranslation(["common", "notification"]);
  const [activeAccountLoading, setActiveAccountLoading] =
    useState<boolean>(false);

  const activeAccount = async () => {
    setActiveAccountLoading(true);

    const activedAccountData = await activeWallet();

    if (activedAccountData.status === "error") {
      commonUtil.showMessage("error", activedAccountData.message);
    } else {
      commonUtil.showMessage("success", "Kích hoạt ví thành công!");

      await fetchCustomerWallet();
      handleChangeView("overview");
    }

    setActiveAccountLoading(false);
  };

  return (
    <Tabs
      defaultActiveKey="1"
      style={{
        borderRadius: "3px",
        padding: "0 16px 16px 16px",
        marginBottom: "16px",
        backgroundColor: "white",
      }}
    >
      <Tabs.TabPane tab={t("common:Thông tin ví")} key="1">
        <Row justify={"center"}>
          <Col>
            <span>Ví của bạn chưa được khởi tạo!</span>
          </Col>
        </Row>
        <Row justify={"center"} style={{ marginTop: "16px" }}>
          <Col>
            <Button
              type="primary"
              loading={activeAccountLoading}
              onClick={activeAccount}
            >
              {t("common:Khởi tạo")}
            </Button>
          </Col>
        </Row>
      </Tabs.TabPane>
    </Tabs>
  );
};

export default WalletActiveAccount;
